import { render, staticRenderFns } from "./sub-product-edit.vue?vue&type=template&id=4d98bdac&scoped=true&"
import script from "./sub-product-edit.vue?vue&type=script&lang=js&"
export * from "./sub-product-edit.vue?vue&type=script&lang=js&"
import style0 from "./sub-product-edit.vue?vue&type=style&index=0&id=4d98bdac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d98bdac",
  null
  
)

export default component.exports